module.exports = __webpack_public_path__ + "static/media/moon.5e3927d8.png";